import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-reciipient-details-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './reciipient-details-icon.component.html',
  styleUrls: ['./reciipient-details-icon.component.scss'],
})
export class ReciipientDetailsIconComponent {
  @Input() color!: string;
}
